import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const ContentContext = createContext({ ...DEFAULT_CONTENT });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const refresh = useCallback(() => {
    axios
      .get(`${API}/content`)
      .then((r) => {
        if (r.data && typeof r.data === "object" && !Array.isArray(r.data)) {
          setContent({ ...DEFAULT_CONTENT, ...r.data });
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ ...content, __refresh: refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
